import {AfterViewInit, ChangeDetectionStrategy, Component, TemplateRef, ViewChild} from '@angular/core';
import {FieldWrapper} from '@ngx-formly/core';

@Component({
  selector: 'formly-mat-addons-wrapper',
  template: `
  <ng-template *ngIf="to.addonLeft" #matPrefix>
    <span [ngClass]="to.addonLeft.class">
      <mat-icon *ngIf="to.addonLeft.icon" class="addon addon--prefix">{{to.addonLeft.icon}}</mat-icon>
      <mat-icon *ngIf="to.addonLeft.svgIcon" class="addon addon--prefix" [svgIcon]="to.addonLeft.svgIcon"></mat-icon>
      <span *ngIf="to.addonLeft.text">{{to.addonLeft.text}}</span>
    </span>
  </ng-template>

  <div class="field-wrapper">
    <ng-container #fieldComponent></ng-container>
  </div>

  <ng-template *ngIf="to.addonRight" #matSuffix>
    <div class="addons">
      <span *ngIf="to.addonRight?.text">{{to.addonRight.text}}</span>
      <mat-icon *ngIf="to.addonRight?.icon" class="addon addon--suffix">{{to.addonRight.icon}}</mat-icon>
      <mat-icon *ngIf="to.addonRight?.svgIcon" class="addon addon--suffix" [svgIcon]="to.addonRight.svgIcon"></mat-icon>
      <!-- <mat-icon class="addon addon--suffix">home</mat-icon> -->
    </div>
  </ng-template>

  `,
  styles: [`
    :host {
      display: flex;
      align-items: baseline;
    }

    .field-wrapper {
      flex-grow: 1;
      max-width: 100%;
    }

    .addons {
      display: inline-flex;
      align-items: center;
    }

    .addon {
      color: rgba(0, 0, 0, 0.54);
    }

    .addon--prefix {
      margin-right: 0.25rem;
    }

    .addon--suffix:not(:first-child) {
      margin-left: 0.5rem;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyMatAddonsWrapperComponent extends FieldWrapper implements AfterViewInit {
  @ViewChild('matPrefix') matPrefix: TemplateRef<any>;
  @ViewChild('matSuffix') matSuffix: TemplateRef<any>;

  ngAfterViewInit() {
    if (this.matPrefix) {
      Promise.resolve().then(() => this.setPrefix());
    }

    if (this.matSuffix) {
      Promise.resolve().then(() => this.setSuffix());
    }
  }

  private setPrefix() {
    this.to.prefix = this.matPrefix;
    (this.options as any)._markForCheck(this.field);
  }

  private setSuffix() {
    this.to.suffix = this.matSuffix;
    (this.options as any)._markForCheck(this.field);
  }
}
